module.exports = __webpack_public_path__ + "static/media/8.be914a33.jpeg";